<template>
  <h2 class="text-xl font-black text-left mt-20 pb-5">鑑定歷程</h2>
  <!------------ 鑑定歷程表格 ------------>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-hidden border-b border-gray-200 rounded-lg">
        <table class="min-w-full divide-y divide-gray-200 table-fixed">
          <caption></caption>
          <thead class="bg-gray-100">
            <tr>
              <th
                scope="col"
                class="
                  px-3
                  py-2
                  text-left
                  font-bold
                  text-gray-500
                  whitespace-nowrap
                  w-36
                "
              >
                鑑定日期
              </th>
              <th
                scope="col"
                class="
                  px-3
                  py-2
                  text-left
                  font-bold
                  text-gray-500
                  whitespace-nowrap
                "
              >
                學名&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
              </th>
              <th
                scope="col"
                class="
                  px-3
                  py-2
                  text-left
                  font-bold
                  text-gray-500
                  whitespace-nowrap
                "
              >
                中文名&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
              </th>
              <th
                scope="col"
                class="
                  px-3
                  py-2
                  text-left
                  font-bold
                  text-gray-500
                  whitespace-nowrap
                  w-36
                "
              >
                鑑定者
              </th>
              <th
                scope="col"
                class="
                  px-3
                  py-2
                  text-left
                  font-bold
                  text-gray-500
                  whitespace-nowrap
                "
              >
                參考文獻&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
              </th>
              <th
                scope="col"
                class="
                  px-3
                  py-2
                  text-left
                  font-bold
                  text-gray-500
                  whitespace-nowrap
                "
              >
                備註&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
              </th>
            </tr>
          </thead>
          <tbody>
            <!------------ 表格資料 ------------>
            <tr
              v-for="(person, personIdx) in reviseRecordData"
              :key="person"
              :class="personIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
            >
              <!-- 鑑定日期 -->
              <td class="px-3 py-2 whitespace-nowrap text-left">{{ person.date_identified_day }}</td>
              <!-- 學名 -->
              <td class="px-3 py-2 text-left">{{ person.taxon_name }}</td>
              <!-- 中文名 -->
              <td class="px-3 py-2 text-left">{{ person.taxon_name_tw }}</td>
              <!-- 鑑定者 -->
              <td class="px-3 py-2 whitespace-nowrap text-left">{{ person.identified_by }}</td>
              <!-- 參考文獻 -->
              <td class="px-3 py-2 text-left">{{ person.references }}</td>
              <!-- 備註 -->
              <td class="px-3 py-2 text-left">{{ person.remark }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getReviseRecordById } from '@/api/survey-data';

export default {
  props: ["surveyDataId"],

  data() {
    return {
      reviseRecordData: null
    }
  },

  async mounted() {
    this.reviseRecordData = await getReviseRecordById(this.surveyDataId, 1)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("err", error.response);
      });
  }
};
</script>
